import { CircularProgress, Box } from "@mui/material";
import { useEffect, useState } from "react";

export default function FullScreenLoader({
  fadeOut = false,
  takeTime = false,
}) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    let timer;

    if (fadeOut) {
      // Começa o fade-out
      timer = setTimeout(() => {
        setIsVisible(false);
      }, 400);
    } else {
      // Volta a exibir imediatamente
      setIsVisible(true);
    }

    return () => clearTimeout(timer);
  }, [fadeOut]);

  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(255,255,255,0.9)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        zIndex: 9999,
        color: "#104467",
        fontSize: "1.2rem",
        gap: "10px",
        opacity: fadeOut ? 0 : 1,
        transition: "opacity 0.4s ease",
      }}
    >
      <CircularProgress sx={{ color: "#104467" }} />
      Carregando...
      {takeTime && (
        <span style={{ fontSize: ".85rem" }}>
          Isso pode demorar um tempo...
        </span>
      )}
    </Box>
  );
}
